export default "__VITE_ASSET__B7ihF6yo__"